<template>
    <div class="usageChartProgressContainer usage-progress-carousel" :class="{ 'is-overview-compact': compact }">
        <div class="progress-box">
            <b-carousel ref="carousel" id="usage-carousel" :interval="5000" :controls="showControls" :no-wrap="false"
                class="usage-carousel">
                <b-carousel-slide v-for="(chunk, chunkIndex) in groupedData" :key="chunkIndex" class="progress-slide">
                    <div class="progress-container" :style="{ gap: computedGap }">
                        <div v-for="(item, index) in chunk" :key="`${chunkIndex}-${index}`">
                            <ProgressBar :item="item" :itemColors="itemColors" :showPrevData="showPrevData" :unit="unit"
                                :widget="widget" :cardHeight="cardHeight" :usageData="processedData"
                                :labelOptions="labelOptions" :compact="compact" ref="progressBar" />
                        </div>
                    </div>
                </b-carousel-slide>
            </b-carousel>
        </div>
    </div>
</template>

<script>
import ProgressBar from "./ProgressBar.vue";

export default {
    components: {
        ProgressBar,
    },
    data() {
        return {
            labelOptions: {
                toFixedConstant: Number(this.widget.objects.main.addition.fixed),
            },
        };
    },
    props: {
        usageData: { type: Array, required: true },
        itemColors: { type: Object, required: true },
        usageMaxValue: { type: Number, default: 100 },
        unit: { type: String, required: true },
        showControls: { type: Boolean, default: false }, // 캐러셀 컨트롤 버튼 표시 여부
        showPrevData: { type: Object, required: true },
        cardHeight: { type: Number, required: true },
        widget: { type: Object, required: true },
        compact: { type: Boolean, default: false },
    },
    watch: {
        groupedData: {
            handler(newVal) {
                this.$emit("update:groupedData", newVal);
            },
        },
    },
    computed: {
        /** 현재 사용량 기준 내림차순 */
        sortedData() {
            return [...this.usageData].sort((a, b) => b.currentConsumpt - a.currentConsumpt);
        },
        processedData() {
            return this.sortedData;
        },
        /** 3개씩 캐러셀 페이지 */
        groupedData() {
            const out = [];
            for (let i = 0; i < this.processedData.length; i += this.limitProgressCount) {
                out.push(this.processedData.slice(i, i + this.limitProgressCount));
            }
            return out;
        },
        limitProgressCount() {
            if (this.cardHeight <= 5) {
                return 3;
            } else if (this.cardHeight <= 10) {
                return 6;
            } else {
                return 10;
            }
        },
        computedGap() {
            if (this.compact) {
                if (this.cardHeight <= 5) return "4px";
                if (this.cardHeight <= 10) return "8px";
                return "12px";
            }
            if (this.cardHeight <= 5) return "10px";
            if (this.cardHeight <= 10) return "20px";
            return "35px";
        },
    },
    methods: {
        /** 다음 슬라이드로 이동 */
        nextSlide() {
            if (this.$refs.carousel) {
                this.$refs.carousel.next();
            }
        },
        /** 이전 슬라이드로 이동 */
        prevSlide() {
            if (this.$refs.carousel) {
                this.$refs.carousel.prev();
            }
        },
    },
};
</script>

<style>
.usageChartProgressContainer .arrow:hover {
    opacity: 0.8;
}

.usageChartProgressContainer .carousel-control-box {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.usageChartProgressContainer .prevDay {
    color: #f55667 !important;
}

.usageChartProgressContainer .prevYear {
    color: #3dc1fe !important;
}

.usageChartProgressContainer .info-box-content {
    padding: 0 !important;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
}

.usageChartProgressContainer .carousel-info {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    width: 100%;
    gap: 2px;
}

.usageChartProgressContainer .carousel-control {
    color: #666;
    font-size: 32px;
    cursor: pointer;
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.usageChartProgressContainer {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.usageChartProgressContainer .progress-box {
    width: 100%;
    height: 100%;
}

.usageChartProgressContainer .info-box {
    /* width: 25%; */
    height: 100%;
    font-size: 12px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    border-left: 1px solid #e0e0e0;
}

/* 컨테이너 & 캐러셀 기본 */
.usageChartProgressContainer .usage-progress-carousel {
    width: 100%;
    height: 100%;
}

.usageChartProgressContainer .usage-carousel {
    height: 100%;
}

/* 슬라이드 */
.usageChartProgressContainer .progress-slide {
    /* padding: 20px; */
    height: 100%;
}

.usageChartProgressContainer .progress-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
}

/* 범례 (사용 시) */
.usageChartProgressContainer .legend {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 10px;
}

.usageChartProgressContainer .legend-item {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
}

.usageChartProgressContainer .legend-color {
    width: 16px;
    height: 16px;
    border-radius: 2px;
    flex-shrink: 0;
}

.current-color {
    background-color: #007bff;
}

.previous-color {
    background-color: #f55667;
}

.last-year-color {
    background-color: #3dc1fe;
}

.legend-text {
    color: #666;
    font-weight: 500;
}

/* 캐러셀 컨트롤 */
.usageChartProgressContainer .carousel-control-prev,
.usageChartProgressContainer .carousel-control-next {
    width: 20px;
    height: 20px;
    background-color: transparent;
    border-radius: 50%;
    top: 50%;
    transform: translateY(-50%);
}

.usageChartProgressContainer .carousel-control-prev-icon,
.usageChartProgressContainer .carousel-control-next-icon {
    background-image: none !important;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.usageChartProgressContainer .carousel-control-prev-icon::after,
.usageChartProgressContainer .carousel-control-next-icon::after {
    content: "";
    display: block;
    width: 10px;
    height: 10px;
    border: solid grey;
    border-width: 0 3px 3px 0;
    padding: 2px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(135deg);
}

.usageChartProgressContainer .carousel-control-next-icon::after {
    transform: translate(-50%, -50%) rotate(-45deg);
}

/* 인디케이터 */
.usageChartProgressContainer .carousel-indicators {
    /* 위치 조정 시 사용 */
}

.usageChartProgressContainer .carousel-indicators li {
    background-color: #007bff;
    border-radius: 50%;
    width: 10px;
    height: 10px;
    margin: 0 5px;
}

.usageChartProgressContainer .carousel-caption {
    top: 7%;
    right: 3%;
    left: 3%;
}

/* 캐러셀 내부 높이 */
.usageChartProgressContainer .carousel-inner {
    height: 100%;
}

.usageChartProgressContainer .carousel-item {
    height: 100%;
}

.usageChartProgressContainer.is-overview-compact .carousel-control {
    font-size: 18px;
}

.usageChartProgressContainer.is-overview-compact .carousel-info,
.usageChartProgressContainer.is-overview-compact .info-box {
    font-size: 10px;
}
</style>
